<template>
  <div id="app" :class="['theme-'+commonParams.sys.theme]">
    <pc-header />
    <router-view></router-view>
    <pc-footer />
  </div>
</template>

<script>
import Header from "../components/Pc/Header.vue"
import Footer from "../components/Pc/Footer.vue"
import {commonParams} from '@/libs/commonParamsStore.js'

export default {
  name: 'App',
  components: {
    PcHeader:Header,
    PcFooter:Footer
  },
  data(){
    return {commonParams}
  },
  watch:{
    commonParams(v){
      console.log(v)
    }
  }
}
</script>

<style lang="less">
@import '../assets/pc.less';

</style>
